import { render, staticRenderFns } from "./LibroCard.vue?vue&type=template&id=0cc36b7e&scoped=true"
import script from "./LibroCard.vue?vue&type=script&lang=js"
export * from "./LibroCard.vue?vue&type=script&lang=js"
import style0 from "./LibroCard.vue?vue&type=style&index=0&id=0cc36b7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc36b7e",
  null
  
)

export default component.exports